import React from 'react';
import { User } from 'lucide-react';

const readProfile = () => {
  try {
    const raw = localStorage.getItem('participantProfile');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Global reusable participant profile summary widget — reads the same
 * `participantProfile` localStorage record populated by the EntryForm widget.
 */
const ProfileCard = ({ className = '' } = {}) => {
  const profile = readProfile();
  const name = profile?.name || 'Guest';
  const initial = name.trim().charAt(0).toUpperCase() || '?';

  return (
    <div className={`profile-card ${className}`.trim()}>
      <div className="profile-card-avatar">
        {initial === '?' ? <User size={26} /> : initial}
      </div>
      <div className="profile-card-body">
        <div className="profile-card-name">{name}</div>
        {profile?.phone && <div className="profile-card-meta">{profile.phone}</div>}
        {profile?.email && <div className="profile-card-meta">{profile.email}</div>}
        {!profile && <div className="profile-card-meta">Enter a code to create your profile</div>}
      </div>
    </div>
  );
};

export default ProfileCard;
